
    import {useStore} from "@/store";
    import {defineComponent, computed, ComputedRef, reactive} from "vue";

    interface EcuBaseInfo {
        license: string;
        vin: string;
        brand: string;
        year: string;
        modelName: string;
        mile: string;
        checkTime: string;

    }

    interface State {
        normalList: object[]; // 检测正常项
        abnormalList: object[]; // 检测异常项
        ecuBaseInfo: EcuBaseInfo;
        normalItemCount: number;
        abnormalItemCount: number;
        isAbnormal: boolean;
        isNormal: boolean;
    }

    export default defineComponent({
        name: "ecuToC",
        setup() {
            let state: State = reactive({
                normalList: [],
                abnormalList: [],
                ecuBaseInfo: {
                    license: '',
                    vin: '',
                    brand: '',
                    year: '',
                    modelName: '',
                    mile: '',
                    checkTime: '',
                },
                isAbnormal: false,
                isNormal: false,
                normalItemCount: 0,
                abnormalItemCount: 0,
            })
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            const {ecuInfo} = dataInfo.value as any

            state.normalList = ecuInfo.normalItems
            state.abnormalList = ecuInfo.unNormalItems
            state.ecuBaseInfo.license = ecuInfo.license
            state.ecuBaseInfo.vin = ecuInfo.vin
            state.ecuBaseInfo.brand = ecuInfo.brand
            state.ecuBaseInfo.year = ecuInfo.year
            state.ecuBaseInfo.modelName = ecuInfo.modelName
            state.ecuBaseInfo.mile = ecuInfo.mile
            state.ecuBaseInfo.checkTime = ecuInfo.checkTime
            state.normalItemCount = ecuInfo.normalItems.length
            state.abnormalItemCount = ecuInfo.unNormalItems.length
            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            },
            changeAbnormal(){
                this.state.isAbnormal = !this.state.isAbnormal
            },
            changeNormal(){
                this.state.isNormal = !this.state.isNormal
            }
        }
    })
